import { render } from "./MovimentacaoShelflife.vue?vue&type=template&id=16b74ef4&scoped=true"
import script from "./MovimentacaoShelflife.vue?vue&type=script&lang=js"
export * from "./MovimentacaoShelflife.vue?vue&type=script&lang=js"

import "./MovimentacaoShelflife.vue?vue&type=style&index=0&id=16b74ef4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b74ef4"]])

export default __exports__